import Control from "ol/control/Control";
import { Map } from "ol";
import { fromLonLat } from "ol/proj";
import { DEFAULT_MAP_CENTER } from "../map-constant";
import i18n from "@/utils/i18n";

export class ZoomControl extends Control {
	constructor(showButtonMe: boolean) {
		const container = document.createElement("div");
		container.className = "ol-control ol-unselectable zoom-reset-control";

		const text = document.createElement("p");
		text.textContent = i18n.t("zoom");

		const zoomInBtn = document.createElement("button");
		zoomInBtn.textContent = "+";

		const zoomOutBtn = document.createElement("button");
		zoomOutBtn.textContent = "−";

		const meBtn = document.createElement("button");
		meBtn.className = "me-zoom";
		meBtn.textContent = i18n.t("me");

		const resetBtn = document.createElement("button");
		resetBtn.className = "reset-zoom";
		resetBtn.textContent = i18n.t("kw");

		if (showButtonMe) {
			container.append(text, zoomInBtn, zoomOutBtn, meBtn, resetBtn);
		} else {
			container.append(text, zoomInBtn, zoomOutBtn, resetBtn);
		}

		super({ element: container });

		zoomInBtn.addEventListener("click", () => {
			const map = this.getMap() as Map;
			const view = map.getView();
			const zoom = Math.round(view.getZoom()!);

			if (zoom === 8) {
				zoomInBtn.disabled = true;
			} else {
				zoomOutBtn.disabled = false;
			}

			view.animate({
				zoom: view.getZoom()! + 1,
				duration: 200,
				center: fromLonLat(DEFAULT_MAP_CENTER),
			});
		});

		zoomOutBtn.addEventListener("click", () => {
			const map = this.getMap() as Map;
			const view = map.getView();
			const zoom = Math.round(view.getZoom()!);

			if (zoom === 6) {
				zoomOutBtn.disabled = true;
			} else {
				zoomInBtn.disabled = false;
			}
			view.animate({
				zoom: view.getZoom()! - 1,
				duration: 200,
				center: fromLonLat(DEFAULT_MAP_CENTER),
			});
		});

		meBtn.addEventListener("click", () => {
			const map = this.getMap() as Map;
			const view = map.getView();
			view.animate({
				zoom: 5.8,
				duration: 200,
				center: fromLonLat(DEFAULT_MAP_CENTER),
			});
		});

		resetBtn.addEventListener("click", () => {
			const map = this.getMap() as Map;
			map.getView().animate({
				zoom: 8,
				center: fromLonLat(DEFAULT_MAP_CENTER),
				duration: 300,
			});
		});
	}
}
